export function getBanners() {
    return {
        type: 'GET_BANNERS',
        payload: {
            request: {
                url: '/banners'
            }
        }
    }
}